//@flow

export const NotificationLevel = {
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
  DANGER: 'danger'
};

export class Notification {
  id: string;
  message: string;
  subject: string;
  level: string;

  constructor(subject: string, message: string, level: string) {

    this.id = Math.random().toString(36).substring(7);
    this.message = message;
    this.level = level;
    this.subject = subject;
    return this;
  }

  getMessage(): string {
    return this.message;
  }
  getLevel(): string {
    return this.level;
  }
  getSubject(): string {
    return this.subject;
  }
  getId(): string {
    return this.id;
  }
};
// export default Notification;
